import { render, staticRenderFns } from "./ProductCreationView.vue?vue&type=template&id=8072a682&"
import script from "./ProductCreationView.vue?vue&type=script&lang=js&"
export * from "./ProductCreationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports